// src/gtag.js

// Grab the Measurement ID from environment variable
export const GA_MEASUREMENT_ID = import.meta.env.VITE_APP_GA_ID;

/**
 * Send a pageview hit to Google Analytics.
 * Call this method on every client-side navigation.
 */
export function pageview(url) {
  if (typeof window.gtag !== 'function') {
    return;
  }
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: url,
  });
}

/**
 * Optionally, if you ever want to fire custom events, you can export an 'event' helper:
 */
export function event({ action, category, label, value }) {
  if (typeof window.gtag !== 'function') {
    return;
  }
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  });
}